var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main"
  }, [_c('section', {
    staticClass: "contact"
  }, [_c('h1', {
    staticClass: "allproducts__title"
  }, [_vm._v("Контакти")]), _vm._v(" "), _c('div', {
    staticClass: "contact__map"
  }, [_c('GMap')], 1), _vm._v(" "), _c('div', {
    staticClass: "contact__form"
  }, [_c('div', {
    staticClass: "contact__form-header"
  }, [(_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "contact__s-column contact__form-header--text"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/home.png"
    }
  }), _vm._v("\n                        " + _vm._s(_vm.settings.address) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "contact__s-column contact__form-header--text"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/phone.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'tel:+' + _vm.settings.phone
    }
  }, [_vm._v(_vm._s(_vm.settings.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "contact__s-column contact__form-header--text"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/envelope.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.settings.email
    }
  }, [_vm._v(_vm._s(_vm.settings.email))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact__form-main"
  }, [_c('form', {
    attrs: {
      "method": "POST",
      "id": "contact"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "contact__m-column"
  }, [_c('div', {
    staticClass: "contact__form-group contact__form-group--first"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Вашите имена")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "contact__input",
    attrs: {
      "type": "text",
      "id": "name",
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.name) ? _c('span', {
    staticClass: "contact__form-group--error",
    domProps: {
      "textContent": _vm._s(_vm.errors.name)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "contact__m-column"
  }, [_c('div', {
    staticClass: "contact__form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Вашия email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "contact__input",
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.email) ? _c('span', {
    staticClass: "contact__form-group--error",
    domProps: {
      "textContent": _vm._s(_vm.errors.email)
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "contact__l-column"
  }, [_c('div', {
    staticClass: "contact__form-group"
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Вашето съобщение")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.message),
      expression: "form.message"
    }],
    staticClass: "contact__input contact__input--textarea",
    attrs: {
      "name": "message",
      "id": "message"
    },
    domProps: {
      "value": (_vm.form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.message) ? _c('span', {
    staticClass: "contact__form-group--error",
    domProps: {
      "textContent": _vm._s(_vm.errors.message)
    }
  }) : _vm._e()])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.formData && _vm.formData.success) ? _c('div', {
    staticClass: "alert alert__success",
    domProps: {
      "textContent": _vm._s(_vm.formData.message)
    }
  }) : _vm._e()])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "contact__l-column contact__btn"
  }, [_c('button', {
    staticClass: "btn btn--success"
  }, [_vm._v("Изпрати")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f12e177e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contacts.vue
// module id = Kwer
// module chunks = 1